module.exports = {"draggableGroups":["today","tomorrow","upcoming","backlog"],"groups":["onboarding","today","tomorrow","upcoming","backlog"],"TODOLIST_PADDING":16,"LINE_MARGIN_BOTTOM":8,"LINE_HEIGHT":48}


//////////////////
// WEBPACK FOOTER
// ./src/features/list/constants.json
// module id = 336
// module chunks = 0